var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block",class:_vm.cssClass,attrs:{"aria-hidden":"true","role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.$t("loading"))+"...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }